import { useMemo } from 'react';

export const useOrderConfig = () => {
  const pessoaFisicaFieldOrder = useMemo(() => [
    'Tipo de Prioridade',
    'Tipo de conta',
    'Nome completo',
    'CPF',
    'E-mail',
    'Telefone',
    'Celular',
    '[Geral] Possui WhatsApp',
    'CEP',
    'Endereço',
    'Bairro',
    'Cidade',
    'Estado',
    'Complemento'
  ], []);

  const pessoaJuridicaFieldOrder = useMemo(() => [
    'Alçada do usuário',
    'Tipo de Prioridade',
    'Tipo de conta',
    '[Geral] Razão social',
    'CNPJ',
    '[Geral] Cognome',
    'E-mail',
    '[Geral] ERP',
    'Telefone',
    'Celular',
    '[Geral] Possui WhatsApp',
    'CEP',
    'Endereço',
    'Bairro',
    'Cidade',
    'Estado',
    'Complemento'
  ], []);

  const transportadoraFieldOrder = useMemo(() => [
    'Alçada do usuário',
    'Tipo de Prioridade',
    'Nome completo',
    'CNPJ',
    '[Geral] Razão social',
    'Telefone',
    'Celular',
    'E-mail',
    '[Transportadora] Código da Transportadora',
    'CEP',
    'Endereço',
    'Bairro',
    'Cidade',
    'Estado',
    'Complemento'
  ], []);

  const postoFieldOrder = useMemo(() => [
    'Nome completo',
    '[Geral] Razão social',
    'CNPJ',
    '[Assistência Técnica] Status da assistência',
    '[Assistência Técnica] Linhas atendidas',
    '[Assistência Técnica] Família Produto',
    'E-mail',
    'Telefone',
    'Celular',
    'CEP',
    'Endereço',
    'Bairro',
    'Cidade',
    'Estado',
    'Complemento',
    'Numero',
  ], []);

  const advogadoFieldOrder = useMemo(() => [
    'Nome completo',
    'CPF',
    '[Advogado] OAB',
    'Tipo de Prioridade',
    'E-mail',
    'Telefone',
    'Celular',
    'CEP',
    'Endereço',
    'Bairro',
    'Cidade',
    'Estado',
    'Complemento'
  ], []);

  const proconFieldOrder = useMemo(() => [
    '[Geral] Razão social',
    'CNPJ',
    '[Geral] ERP',
    'Tipo de Prioridade',
    'E-mail',
    'Telefone',
    'Celular',
    'CEP',
    'Endereço',
    'Bairro',
    'Cidade',
    'Estado',
    'Complemento'
  ], []);

  const getFieldPosition = (title: string, tipoConta: string | null, selectedRole: string | null) => {
    if (selectedRole === 'transportadora') {
      for (let i = 0; i < transportadoraFieldOrder.length; i++) {
        if (title.includes(transportadoraFieldOrder[i])) {
          return i;
        }
      }
    } else if (selectedRole === 'posto') {
      for (let i = 0; i < postoFieldOrder.length; i++) {
        if (title.includes(postoFieldOrder[i])) {
          return i;
        }
      }
    } else if (selectedRole === 'procon' || selectedRole === 'revenda') {
      for (let i = 0; i < proconFieldOrder.length; i++) {
        if (title.includes(proconFieldOrder[i])) {
          return i;
        }
      }
    } else if (selectedRole === 'advogado' || selectedRole === 'juiz') {
      for (let i = 0; i < advogadoFieldOrder.length; i++) {
        if (title.includes(advogadoFieldOrder[i])) {
          return i;
        }
      }
    } else if (tipoConta === 'pessoa_fisica') {
      for (let i = 0; i < pessoaFisicaFieldOrder.length; i++) {
        if (title.includes(pessoaFisicaFieldOrder[i])) {
          return i;
        }
      }
    } else if (tipoConta === 'pessoa_juridica') {
      for (let i = 0; i < pessoaJuridicaFieldOrder.length; i++) {
        if (title.includes(pessoaJuridicaFieldOrder[i])) {
          return i;
        }
      }
    }

    const defaultOrder = {
      'Tipo de Prioridade': 0,
      'Tipo de conta': 1,
      'Nome completo': 2,
      CPF: 3,
      'E-mail': 4,
      Telefone: 5,
      'Celular': 6,
      '[Geral] Possui WhatsApp': 7,
      'CEP -ENDEREÇO': 8,
      'Cidade': 9,
      'Estado': 10,
      'Complemento': 11
    };

    for (const [key, value] of Object.entries(defaultOrder)) {
      if (title.includes(key)) return value;
    }

    return 100;
  };

  return { getFieldPosition };
};